import { DocumentLanguage, DocumentType, isDocumentType } from './documentTypes';

export interface MessageMapping { position: number; field?: string; text?: string }
/** The WhatsApp template sent for this type's event, with the document fields mapped to its values. */
export interface DocumentMessageTemplate { templateId: string; mappings: MessageMapping[] }

export interface DocumentTemplateDraft {
  name: string;
  type: DocumentType;
  language: DocumentLanguage;
  htmlContent: string;
  logoUrl: string;
  colors: { primary: string; secondary: string; text?: string; background?: string };
  isDefault: boolean;
  messageTemplate: DocumentMessageTemplate | null;
}

export function templateDraft(source: any, fallback: { type: DocumentType; name: string; html: string; logo?: string }, copyName?: string): DocumentTemplateDraft {
  const saved = source?.messageTemplate;
  return {
    name: copyName ?? source?.name ?? fallback.name,
    type: isDocumentType(source?.type) ? source.type : fallback.type,
    language: ['auto', 'en', 'ar', 'bilingual'].includes(source?.language) ? source.language : 'auto',
    htmlContent: source?.htmlContent || fallback.html,
    logoUrl: source?.logoUrl ?? fallback.logo ?? '',
    colors: { ...source?.colors, primary: source?.colors?.primary || '#1a56db', secondary: source?.colors?.secondary || '#6b7280' },
    isDefault: copyName === undefined && !!source?.isDefault,
    messageTemplate: copyName === undefined && typeof saved?.templateId === 'string' ? { templateId: saved.templateId, mappings: Array.isArray(saved.mappings) ? saved.mappings : [] } : null,
  };
}

export function templateDesignMode(html: string, standard: string): 'standard' | 'canvas' | 'code' {
  if (html.trim() === standard.trim()) return 'standard';
  return /\bdata-block-id\s*=/.test(html) ? 'canvas' : 'code';
}

export const validTemplateColor = (value: string) => /^#(?:[a-f\d]{3}|[a-f\d]{6})$/i.test(value);
